import { Avatar, Tag, Text } from '_/space-management/components';
import { DATETAB_TIME_FORMAT } from '_/space-management/config/date';
import { colors } from '_/space-management/constants/theme';
import { formatDate } from '_/space-management/helpers/formatDate';
import { EventStatus } from '_/space-management/services/models/enums/event-status.enum';
import { EventsResponse } from '_/space-management/services/models/events.model';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useAuth } from '_/space-management/hooks/AuthContext';
import { Role } from '_/space-management/services/models/enums/role.enum';

import styles from './styles';
import { fontSizes } from '_/config/theme';

interface WhoReservedProps {
  event: EventsResponse;
}

export default function WhoReserved({ event }: WhoReservedProps) {
  const { t } = useTranslation();
  const { member } = useAuth();

  const isReserver = event.createdToMemberId === member?.id || event.user?.id === member?.userId;
  const canSeeDetails = member?.role === Role.ADMIN || isReserver;

  return (
    <View style={styles.whoReservedContainer}>
      <View style={styles.userInfo}>
        <Avatar size={40} source={canSeeDetails ? event.user?.pictureThumbUrl : undefined} />
        <View style={styles.userArea}>
          <Text fontType="bold" numberOfLines={1} fontSize={fontSizes.md2} style={styles.username}>
            {canSeeDetails ? event.user?.name : t('spaceManage.reserved')}
          </Text>
          {event.checkoutAt && (
            <Tag text="check-out" backgroundColor={colors.errorRed} style={styles.checkoutTag} />
          )}
          {event.status === EventStatus.CONFIRMED && (
            <Tag
              text={t('spaceManage.confirmed')}
              backgroundColor={colors.successGreen}
              style={styles.checkoutTag}
            />
          )}
          {event.status === EventStatus.PENDING && (
            <Tag text={t('spaceManage.pending')} backgroundColor={colors.yellow} style={styles.checkoutTag} />
          )}
        </View>
      </View>
      <View style={styles.slotInfo}>
        <Text fontSize={fontSizes.md2} numberOfLines={1} fontType="bold">
          {event.slot!.name}
        </Text>
        <Text fontSize={fontSizes.sm} color={colors.grey}>
          {formatDate(Date.parse(event.checkinAt || event.startAt), DATETAB_TIME_FORMAT)} às{' '}
          {formatDate(Date.parse(event.checkoutAt || event.endAt), DATETAB_TIME_FORMAT)}
        </Text>
      </View>
    </View>
  );
}
